import React, { useState, useEffect } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  Grid,
  Grid2,
  IconButton,
  TextField,
  Typography,
} from '@mui/material'
//import TelegramIcon from '../../assets/images/telegram.webp'
import TelegramIcon from '../../assets/images/telegram.webp'
import SignalIcon from '../../assets/images/signal.webp'
import WhatsAppIcon from '../../assets/images/whatsapp.webp'
import Menu from '../Menu/Menu'
import './Header.css'
import myImage from '../../assets/images/Logo.png'
import SearchIcon from '@mui/icons-material/Search'
import { useTheme, useMediaQuery } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { FloatingSocialButton } from '../../components/SocialNetw/FloatingSocialButton'
import ContactDialog from './ContactDialog'

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const theme = useTheme()
  const navigate = useNavigate()

  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const isNarrow = useMediaQuery('(max-width:1100px)')

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return
      }
      setIsOpen(open)
    }

  const menuItems = [
    { label: 'Home', path: '/' },
    { label: 'About Us', path: '/aboutUs' },
    { label: 'Our Games', path: '/ourGames' },
    { label: 'News', path: '/news_blog' },
    // { label: 'Contact Us', path: '/contactUs' },
  ]

  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const [form, setForm] = useState({
    name: '',
    email: '',
    country: '',
    phone: '',
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    setIsDialogOpen(false)
  }

  return (
    <>
      <Box>
        <Grid2 className='header'>
          <Grid2 className='header-inner'>
            <FloatingSocialButton visible={!isOpen} />

            <Box>
              <img
                src={myImage}
                alt='8Rabbits'
                style={{
                  height: '80%',
                  position: 'absolute',
                  top: '10px',
                  display: 'block',
                }}
              />
            </Box>
            {!isMobile ? (
              <Grid
                item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: isNarrow ? 1.5 : 3,
                }}
              >
                {menuItems.map(item => (
                  <Typography
                    key={item.label}
                    variant='body1'
                    className={`menu-Items ${scrolled ? 'scrolled' : ''}`}
                    onClick={() => navigate(item.path)}
                  >
                    {item.label}
                  </Typography>
                ))}

                <Box sx={{ gap: '0.2rem' }}>
                  <IconButton
                    sx={{
                      mr: '10px',
                      color: 'white',
                      ':hover': {
                        color: '#4CAF50',
                      },
                    }}
                  >
                    <SearchIcon />
                  </IconButton>

                  <Button
                    variant='contained'
                    className='headerButton1'
                    onClick={() => setIsDialogOpen(true)}
                  >
                    Community
                  </Button>
                </Box>

                <Button
                  variant='contained'
                  className='headerButton2'
                  onClick={() => setIsDialogOpen(true)}
                >
                  Contact
                </Button>
              </Grid>
            ) : (
              <Button
                className='button-header-menu'
                onClick={toggleDrawer(true)}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='40'
                  height='40'
                  viewBox='0 0 25 24'
                  fill='#00DA33'
                >
                  <path
                    d='M3.5 18V16H21.5V18H3.5ZM3.5 13V11H21.5V13H3.5ZM3.5 8V6H21.5V8H3.5Z'
                    fill='#00DA33'
                  />
                </svg>
              </Button>
            )}
          </Grid2>
          {<Menu isOpen={isOpen} toggleDrawer={toggleDrawer} />}
        </Grid2>
      </Box>
      <ContactDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        form={form}
        onChange={handleChange}
        onSubmit={handleSubmit}
        icons={{
          whatsapp: WhatsAppIcon,
          telegram: TelegramIcon,
          signal: SignalIcon,
        }}
      />

      {/* <Dialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        maxWidth='xs'
        fullWidth
        sx={{ '.MuiPaper-root': { borderRadius: '14px' } }}
      >
        <DialogTitle>
          <Box display='flex' justifyContent='center' gap={2}>
            <IconButton
              sx={{
                position: 'relative',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  backdropFilter: 'blur(.5px)',
                  zIndex: 1400,
                },
              }}
              href='https://wa.me/'
              target='_blank'
            >
              <img
                style={{ width: 40, height: 40 }}
                src={WhatsAppIcon}
                alt='whatsapp'
              />
            </IconButton>
            <IconButton
              sx={{
                position: 'relative',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  backdropFilter: 'blur(.5px)',
                  zIndex: 1400,
                },
              }}
              href='https://t.me/'
              target='_blank'
            >
              <img
                style={{ width: 40, height: 40 }}
                src={TelegramIcon}
                alt='telegram'
              />
            </IconButton>
            <IconButton
              sx={{
                position: 'relative',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  backdropFilter: 'blur(.5px)',
                  zIndex: 1400,
                },
              }}
              href='https://signal.org/'
              target='_blank'
            >
              <img
                style={{ width: 38, height: 38 }}
                src={SignalIcon}
                alt='signal'
              />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider variant='middle' sx={{ borderColor: '#4CAF50' }} />
        <DialogContent>
          <Box
            component='form'
            onSubmit={handleSubmit}
            sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}
          >
            <TextField
              label='Name'
              name='name'
              value={form.name}
              onChange={handleChange}
              required
              fullWidth
              size='small'
            />
            <TextField
              label='Email'
              name='email'
              type='email'
              value={form.email}
              onChange={handleChange}
              required
              fullWidth
              size='small'
            />
            <TextField
              label='Phone'
              name='phone'
              value={form.phone}
              onChange={handleChange}
              fullWidth
              size='small'
            />
            <TextField
              label='Country'
              name='country'
              value={form.country}
              onChange={handleChange}
              required
              fullWidth
              size='small'
            />
            <Button
              sx={{ height: 40, backgroundColor: '#4CAF50' }}
              type='submit'
              variant='contained'
              fullWidth
            >
              Send
            </Button>
          </Box>
        </DialogContent>
      </Dialog> */}
    </>
  )
}

export default Header
